module.exports = __webpack_public_path__ + "static/media/conference.df9307c3.svg";